import styled from 'styled-components';

import { Box } from '@/shared/ui/box';
import { Breadcrumbs } from '@/shared/ui/breadcrumbs';
import { Title as SharedTitle } from '@/shared/ui/title';

import { StyledParagraph } from './page-wrapper.types';

export const Wrapper = styled.main`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const ScrollableContent = styled.div<StyledParagraph>`
	flex: 1;
	padding: 0 24px ${({ paragraph }) => paragraph};
	display: flex;
	flex-direction: column;
	overflow: ${({ overflow }) => overflow};

	@media ${({ theme: { media } }) => media.mobileAndLaptop} {
		padding: 0 18px ${({ paragraph }) => paragraph};
	}

	@media ${({ theme: { media } }) => media.mobile} {
		padding: 0 18px ${({ paragraph }) => paragraph};
	}
`;

export const Title = styled(SharedTitle)`
	margin-bottom: 32px;

	@media ${({ theme: { media } }) => media.mobileAndLaptop} {
		padding: 0 24px;
	}
`;

export const InnerWrapper = styled(Box)`
	${({ theme: { page } }) => ({ ...page.wrapper })}

	& > * {
		max-width: 1190px;
	}
`;

export const PageBreadCrumbs = styled(Breadcrumbs)`
	@media ${({ theme: { media } }) => media.mobileAndLaptop} {
		padding: 0 24px;
	}

	@media ${({ theme: { media } }) => media.mobile} {
		padding: 0;
	}
`;

export const PageTitle = styled(SharedTitle)`
	@media ${({ theme: { media } }) => media.mobileAndLaptop} {
		padding: 0 24px;
	}

	@media ${({ theme: { media } }) => media.mobile} {
		padding: 0;
	}
`;

export const PageHeaderTitle = styled(SharedTitle)``;

export const FooterAction = styled(Box)`
	transition: ${({ theme: { transition } }) => transition.primary};
	padding: 16px 32px;

	@media ${({ theme: { media } }) => media.mobileAndLaptop} {
		padding: 16px 18px;
	}

	&:hover {
		opacity: 0.85;
	}
`;
